<template>
	<div class="flex items-center justify-center min-h-screen">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import { useRouter } from "vue-router"
import { authProvider } from "../auth/authProviderFactory"
import { appAuth } from "../auth/appAuth"

const router = useRouter()

onMounted(async () => {
	try {
		const { accessToken } = await authProvider.handleCallback()
		if (accessToken) {
			localStorage.setItem("token", accessToken)
			const result = await appAuth.loginToAppWithOktaToken(accessToken)
			if (result === "ok") {
				router.push("/app")
			} else {
				sessionStorage.setItem("error", result)
				router.push("/login")
			}
		} else {
			router.push("/login")
		}
	} catch (error) {
		console.error("Auth callback error:", error)
		router.push("/login")
	}
})
</script>
